export class InputManager {
  private keys = {
    left: false,
    right: false,
    tiltLeft: false,
    tiltRight: false,
    smashTriggered: false,
    spaceTriggered: false,
  };

  private touchMove: number = 0;
  private touchTilt: number = 0;
  private lastTapTime: number = 0;

  constructor() {
    this.setupKeyboard();
    this.setupTouch();
  }

  private setupKeyboard(): void {
    window.addEventListener('keydown', (e: KeyboardEvent) => {
      if (e.key === 'a' || e.key === 'A') this.keys.left = true;
      if (e.key === 'd' || e.key === 'D') this.keys.right = true;
      if (e.key === 'q' || e.key === 'Q') {
        this.keys.tiltLeft = true;
      }
      if (e.key === 'e' || e.key === 'E') {
        this.keys.tiltRight = true;
      }
      if (e.key === 'w' || e.key === 'W') {
        this.keys.smashTriggered = true;
      }
      if (e.code === 'Space' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        this.keys.spaceTriggered = true;
      }
    });

    window.addEventListener('keyup', (e: KeyboardEvent) => {
      if (e.key === 'a' || e.key === 'A') this.keys.left = false;
      if (e.key === 'd' || e.key === 'D') this.keys.right = false;
      if (e.key === 'q' || e.key === 'Q') this.keys.tiltLeft = false;
      if (e.key === 'e' || e.key === 'E') this.keys.tiltRight = false;
    });
  }

  private setupTouch(): void {
    window.addEventListener(
      'touchstart',
      (e: TouchEvent) => {
        if (e.touches.length > 0) {
          const touchX = e.touches[0].clientX;
          const halfWidth = window.innerWidth / 2;

          if (touchX < halfWidth) {
            this.touchMove = 1; // Counterclockwise / Left
          } else {
            this.touchMove = -1; // Clockwise / Right
          }

          // Double-tap to smash
          const now = Date.now();
          if (now - this.lastTapTime < 300) {
            this.keys.smashTriggered = true;
          }
          this.lastTapTime = now;
        }
      },
      { passive: true }
    );

    window.addEventListener(
      'touchend',
      () => {
        this.touchMove = 0;
        this.touchTilt = 0;
      },
      { passive: true }
    );
  }

  getMove(): number {
    let move = 0;
    if (this.keys.left) move += 1;
    if (this.keys.right) move -= 1;
    if (this.touchMove !== 0) move = this.touchMove;

    // Gamepad support
    const gp = this.getGamepad();
    if (gp) {
      const axisX = gp.axes[0];
      if (Math.abs(axisX) > 0.15) {
        move = -axisX;
      }
    }

    return move;
  }

  getTilt(): number {
    let tilt = 0;
    if (this.keys.tiltLeft) tilt -= 1;
    if (this.keys.tiltRight) tilt += 1;
    if (this.touchTilt !== 0) tilt = this.touchTilt;

    const gp = this.getGamepad();
    if (gp) {
      const rightX = gp.axes[2];
      if (Math.abs(rightX) > 0.2) {
        tilt = rightX;
      }
    }

    return tilt;
  }

  consumeSmash(): boolean {
    const gp = this.getGamepad();
    let gpSmash = false;
    if (gp) {
      // Button A (index 0) or Button Y (index 3) or Right Trigger (index 7)
      if (
        (gp.buttons[0] && gp.buttons[0].pressed) ||
        (gp.buttons[3] && gp.buttons[3].pressed) ||
        (gp.buttons[7] && gp.buttons[7].pressed)
      ) {
        gpSmash = true;
      }
    }

    if (this.keys.smashTriggered || gpSmash) {
      this.keys.smashTriggered = false;
      return true;
    }
    return false;
  }

  consumeSpace(): boolean {
    if (this.keys.spaceTriggered) {
      this.keys.spaceTriggered = false;
      return true;
    }
    return false;
  }

  private getGamepad(): Gamepad | null {
    if (typeof navigator !== 'undefined' && navigator.getGamepads) {
      const gamepads = navigator.getGamepads();
      for (let i = 0; i < gamepads.length; i++) {
        if (gamepads[i]) return gamepads[i];
      }
    }
    return null;
  }
}
